import React, { Component } from "react";
import Button from "./Button";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

class CheckoutProcessing extends Component {
  componentDidMount = async () => {
    this.props.initPaysafe();
  }

  render() {
    const { settings, title, paysafe_after_payclick, initPaysafe, paysafe_status, goToPrevious } = this.props;
    return (
      <form key={4} className="w-full md:w-2/3">
        <Helmet>
          {settings.scripts_payment_info && <script>{settings.scripts_payment_info}</script>}
        </Helmet>
        <h2 className="mb-6">{title}</h2>
        <div className="flex flex-wrap items-center h-64">
          <div className="w-2/3 m-auto">
            {paysafe_status ? (
              <div className="flex text-2xl text-primary">
                <div className="bump-loader" style={{ position: 'relative', marginRight: '20px', marginTop: '-15px', left: '0%' }}>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
                {paysafe_after_payclick ? "Processing payment..." : "Redirecting to payment gateway..."}
              </div>
            ) : (<div><div className="flex text-2xl text-primary">You have cancelled the payment. Would you like to go back to the payment page?</div>
              <div className="w-full flex flex-wrap mt-12 justify-between">
                <Button onClick={goToPrevious} color="secondary" textColor="primary" content={"Back"} />
                <Link
                  to={"/"}
                  className="no-underline py-3 px-6 bg-danger hover:bg-primary-dark text-primary-contrast">
                  Cancel Order
              </Link>
                <Button onClick={initPaysafe} color="primary" content={"Make Payment"} />
              </div>
            </div>)}
          </div>
        </div>
      </form>
    );
  }
}

export default CheckoutProcessing;
